import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './plugins/element.js'
import './plugins/plugin.js'

Vue.config.productionTip = false;



var nocheck = ['DEMO', 'LOGIN', 'TEST']; //'FLEXMONSTER', 'INDEX', 'CHARTMGR', 'TEST', 'EQUIPANALYSIS', 'EQUIPGRADIENTANALYSIS', 'EQUIPCOMPARE', 'EQUIPMODELCOMPARE'
var isLogin = localStorage.getItem('ss');
router.beforeEach((to, from, next) => {
    if (!isLogin) {
        if (nocheck.indexOf(to.name.toUpperCase()) < 0) {
            return next('/Login');
        }
    }
    next();
});


Vue.prototype.saleMenu = [{ "name": "子车型销量", "link": "#/saleanalysis", "icon": "model_sale" },
    { "name": "车款销量", "link": "#/linesaleanalysis", "icon": "line_sale" },
    { "name": "装备销量", "link": "#/equipsaleanalysis", "icon": "equip_sale" }

];

Vue.prototype.equipMenu = [{ "name": "装备表", "link": "#/equipanalysis", "icon": "table" },
    { "name": "装备梯度", "link": "#/equipgradientanalysis", "icon": "td" },
    { "name": "子车型对比", "link": "#/equipmodelcompare", "icon": "sub_model" },
    { "name": "车款对比", "link": "#/equipcompare", "icon": "model_equip" },
    { "name": "装备率", "link": "#/equipmentrateanalysis", "icon": "zbl" }
];
//生命周期、装车 、pva、日报 、 月报
Vue.prototype.modelMenu = [{ "name": "生命周期研究", "link": "#/modeltimeline", "icon": "life_cycle" },
    { "name": "装车率", "link": "#/einbaurateanalysis", "icon": "zcl" },
    { "name": "客户价值分析", "link": "#/pva", "icon": "pva" },
    { "name": "日报", "link": "#/dailyreport", "icon": "day_report2" },
    { "name": "月报", "link": "#/monthlyreport", "icon": "monthly_report2" },
    /* { "name": "谍报", "link": "#/espionage", "icon": "spy" }*/
];
Vue.prototype.gainMenu = [{ "name": "MADE价格指数", "link": "#/gain", "icon": "gain" },{ "name": "MADE Charts", "link": "#/gaincharts", "icon": "gain_index" }];
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')